import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { callApi, formatMoney, getInlineLoader, setCookie } from "../Helpers";
import {
	STR_AMOUNT_2,
	STR_BALANCE,
	STR_CHANGE_PHONE_NUMBER,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_FILL_IN_RECEIVER_DETAILS_CORRECTLY,
	STR_HOTEL,
	STR_HOTEL_MENU,
	STR_LOGOUT,
	STR_MIN_50000,
	STR_MY_COACH,
	STR_MY_HOTELS,
	STR_MY_STUDENTS,
	STR_NO_PERMISSION,
	STR_NO_RECORD,
	STR_PAYMENT_SETTINGS,
	STR_PERSONAL_SETTINGS,
	STR_RECEIVER_METHOD,
	STR_RECEIVER_NAME,
	STR_RECEIVER_NUMBER,
	STR_REVENUE,
	STR_REVENUE_AND_WITHDRAWALS,
	STR_ROOM_BOOKINGS,
	STR_ROOMS,
	STR_SEND_WITHDRAW_REQUEST,
	STR_SET_CURRENCY,
	STR_SUBMIT,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_TAB_REVENUES,
	STR_TAB_WITHDRAWALS,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME,
	STR_USER_REPORT,
	STR_WHATSAPP_SETUP,
	STR_WITHDRAWAL_HISTORY
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdAnalytics, MdCheckCircle, MdContactPage, MdDashboard, MdInfoOutline, MdList, MdLogout, MdManageAccounts, MdMoney, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdPerson, MdSupportAgent, MdTranslate, MdWarning, MdWhatsapp } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import { GrCurrency } from "react-icons/gr";
import { GiTeacher } from "react-icons/gi";
import { FaRegUser } from "react-icons/fa";
import WelcomeSlider from "../ones/WelcomeSlider";
import { RiHotelLine } from "react-icons/ri";
import TabbedView from "../components/TabbedView";
import OneHotelRoom from "../ones/OneHotelRoom";

export default function View({ hotelId }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);
	const [hotelData,  setHotelData] = useState(null);
	const [hotelRooms,  setHotelRooms] = useState(null);


	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			appContext.getCurrentUserData(),
			getHotelData(),
			getHotelRooms(),
		])
		setReady(true);
	}

	
	async function getHotelData() {
		await callApi('get-current-hotel-data', { id: hotelId }).then((response) => {
			if(response.status === 1) {
				setHotelData(response.data)
			} else {
				appContext.tellError('Could not fetch data, check network')
			}
		})
	}

	
	
	async function getHotelRooms() {
		await callApi('get-hotel-rooms', { hotelId }).then((response) => {
			if(response.status === 1) {
				setHotelRooms(response.data)
			} else {
				appContext.tellError('Could not fetch data, check network')
			}
		})
	}

	const Rooms = (
		<div
			className=""
			style={{
				width: "100%"
			}}
		>
			{
				(hotelRooms && hotelRooms.length > 0) ?
				<div className="row">
					{
						hotelRooms.map((item, i) => {
							return (
								<div className="col-6" key={i}>
									<OneHotelRoom
										
										data={item}
										viewer='manager'
									/>
								</div>
							)
						})
					}
				</div>
				:
				<h6>{STR_NO_RECORD[appContext.language]}</h6>
			}
		</div>
	);

	

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	if (ready && hotelData) {
		return (
			<div
				style={{
					width: "100%",
					height: "100%",
					overflow: "scroll",
					paddingTop: "20px",
					paddingBottom: "calc(var(--topBarHeight) + 40px)",
				}}
				className="mNoScrollBar"
			>
				<div className="container">

					<div className="row">

						{
							(Number(appContext.currentUserData.id) === Number(hotelData.managerId)) ?
							<div className="col-md-12">
								<div className="card mb-5">
									<div className="card-body text-center">
										
										<h6
											className="text-primary font-light mt-3 mb-3"
											style={{
												fontSize: "28px"
											}}
										>
											{hotelData.name}
										</h6>

										<span className="badge bg-secondary">{STR_HOTEL[appContext.language]}</span>
									</div>
								</div>

								<h6 className="main-section-title">
									{STR_ROOMS[appContext.language]}
								</h6>


								{Rooms}

							</div>
							:
							<div className="col-md-12">
								<div className="card">
									<div className="card-body text-center">
										<MdWarning size={56} className="text-secondary"/>

										<h6
											style={{
												fontSize: "22px"
											}}
											className="font-semi-bold"
										>
											{STR_NO_PERMISSION[appContext.language]}
										</h6>
									</div>
								</div>
							</div>
						}
					 

					</div>

				</div>


			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}